import $ from 'jquery';

if( navigator.userAgent.match(/iPhone|iPad|iPod/i) ) {
	document.addEventListener('focusout', function() {
		$('.modal').css({position: 'absolute'});
		window.scrollTop();
	});
}



// WEBPACK FOOTER //
// ./source/common/ios/ioskeyboardfix.js